module.exports = __webpack_public_path__ + "img/arw-circle-red.74b0c137.svg";